export default function Logo({ variant = "color", className = "h-6" }) {
  const src = variant === "white" ? "/prodigitas-logo.svg" : "/prodigitas-logo-alt.svg";
  return (
    <img
      src={src}
      alt="Prodigitas"
      className={`${className} w-auto select-none`}
      draggable="false"
      data-testid="logo-prodigitas"
    />
  );
}
